export default "__VITE_ASSET__CD6jNz34__"